module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/mail-builder/mail-builder.component.css
// module id = ./src/app/mail-builder/mail-builder.component.css
// module chunks = main